<button mat-icon-button tabindex="1" class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<h1 mat-dialog-title>{{ data.title || 'Confirmación' }}</h1>

<div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <p *ngIf="data.message">
    {{ data.message }}
  </p>
  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ data.placeholder || 'Descripción' }}</mat-label>
      <textarea matInput formControlName="description" [placeholder]="data.placeholder || 'Ingrese una descripción...'"
        rows="3" [maxlength]="data.maxLength || 200">
            </textarea>
      <mat-hint align="end" class="char-counter">
        {{ form.get('description')?.value?.length || 0 }}/{{ data.maxLength || 200 }}
      </mat-hint>
      <mat-error *ngIf="form.get('description')?.hasError('required')">
        La descripción es requerida
      </mat-error>
      <mat-error *ngIf="form.get('description')?.hasError('maxlength')">
        Máximo {{ data.maxLength || 200 }} caracteres
      </mat-error>
    </mat-form-field>
  </form>
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onCancel()" class="cancel-button">
    <mat-icon>close</mat-icon>
    {{ data.noText || 'Cancelar' }}
  </button>
  <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="!isFormValid()" class="confirm-button">
    <mat-icon>check</mat-icon>
    {{ data.yesText || 'Confirmar' }}
  </button>
</div>
